export default "mutation RequestQuote($request: RequestQuoteInput!){\n  requestQuote(request: $request)\n}";